module.exports = __webpack_public_path__ + "img/super-icon.c696631c.svg";